<template>
    <div ref="reports_container" class="reports-container" :style="{'--primary-color': query.payType == '支出' ? '#3eb475' : '#eeb63b'}">
        <div class="reports-header">
            <div class="header-query">
                <div class="query-item" @click="handleQueryPayDate">
                    <a-icon style="font-size: 18px" type="schedule" />
                    <span class="item-line"></span>
                    <span>{{query.payDate}}</span>
                </div>
                <div class="query-item" @click="handlePayType">
                    <span class="item-pay-type"
                          @click="query.payType = '支出'"
                          :class="query.payType == '支出' ? 'item-pay-type-active' : ''">支出</span>
                    <span class="item-pay-type"
                          @click="query.payType = '收入'"
                          :class="query.payType == '收入' ? 'item-pay-type-active' : ''">收入</span>
                </div>
            </div>
            <div class="header-report">
                <div class="report-title">共{{query.payType}}</div>
                <div class="report-price">
                    <span class="price-value">{{reportsMoney}}</span>
                </div>
            </div>
        </div>
        <div class="reports-tags">
            <div class="tags-title">{{this.query.payType}}构成</div>
            <div style="width: 100%; height: 300px" ref="tags_echarts"></div>
            <div class="tags-list" v-if="tagsData && tagsData.length > 0">
                <div class="list-item" v-for="item in tagsData" :key="item.tag" @click="handleTagsListItem(item)">
                    <div class="item-index">
                        <a-icon :type="item.tagIcon || 'red-envelope'" theme="filled"/>
                    </div>
                    <div class="item-title">{{item.tag}}</div>
                    <div class="item-percent">
                        <div :style="{width: getPercent(item.percent) + '%'}" class="percent-value"></div>
                    </div>
                    <div class="item-price">{{item.money}}元</div>
                    <div class="item-more">
                        <a-icon type="right" />
                    </div>
                </div>
            </div>
        </div>
        <div class="reports-month">
            <div class="month-title">{{query.payDate.split('年')[0]}}年月度对比</div>
            <div style="width: 100%; height: 600px; overflow: hidden" ref="month_echarts"></div>
        </div>
        <date-select-drawer ref="date_select_drawer" @select="handleSelectDate"></date-select-drawer>
    </div>
</template>

<script>
import DateSelectDrawer from "@/view/mypaymentrecord/components/DateSelectDrawer.vue";
import * as echarts from 'echarts'
import {getPaymentReports} from "@/api/payment";
export default {
    name: "index",
    components: {DateSelectDrawer},
    inject: ['setLoading'],
    data() {
        return {
            query: {
                payDate: this.$formatDate(new Date(), 'yyyy年M月'),
                payType: '支出'
            },
            tagsData: [],
            reportsMoney: 0,
            tagsEcharts: null,
            monthEcharts: null,
        }
    },
    watch: {
        query: {
            handler() {
                sessionStorage.setItem('payment_reports_query', JSON.stringify(this.query))
            },
            deep: true
        }
    },
    mounted() {
        const query = sessionStorage.getItem('payment_reports_query')
        if (query) {
            this.query = JSON.parse(query)
        }
        this.tagsEcharts = echarts.init(this.$refs['tags_echarts'])
        this.monthEcharts = echarts.init(this.$refs['month_echarts'])
        this.getReports()
    },
    methods: {
        getReports() {
            this.setLoading(true)
            getPaymentReports({
                date: this.query.payDate,
                payType: this.query.payType
            }).then(res => {
                this.reportsMoney = res.data.money
                const tagsData = res.data.tagInfoVoList
                this.tagsData = tagsData
                this.getTagsData(tagsData.map(item => ({
                    value: item.money,
                    name: item.tag
                })))
                const yearMonthReportsVo = res.data.yearMonthReportsVo
                this.getMonthData(
                    yearMonthReportsVo.monthList,
                    yearMonthReportsVo.incomeMoneyList,
                    yearMonthReportsVo.outcomeMoneyList)
            }).finally(() => {
                this.setLoading(false)
            })
        },
        getTagsData(data) {
            // 实例：data = [{ value: 22.82, name: '医疗' }]
            const primaryColor = this.$refs['reports_container'].style.getPropertyValue('--primary-color')
            const colorList = data.map((item, index) => this.getColorRgba(primaryColor, (data.length - index) / data.length))
            // 设置图表配置项
            const option = {
                // 环形图
                series: [
                    {
                        type: 'pie',
                        top: '-30px',
                        radius: ['30%', '45%'], // 内外半径，形成环形
                        data: data,
                        // 图形样式
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        // 标签配置
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b} {d}%',
                            color: '#666',
                            fontSize: 10,
                        },
                        // 标签连线配置
                        labelLine: {
                            show: true,
                            length2: 6,
                            smooth: 0,
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        // 使用生成的颜色列表
                        color: colorList
                    }
                ]
            }
            this.tagsEcharts.setOption(option);
        },
        getMonthData(monthArray, incomeArray, outcomeArray) {
            const primaryColor = this.$refs['reports_container'].style.getPropertyValue('--primary-color')
            const oneHeight = monthArray.length < 8 ? 70 : 40
            this.$refs['month_echarts'].style.height = (monthArray.length * oneHeight + 100) + 'px'
            // 配置项
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: ([params1, params2]) => {
                        if (!params1 && !params2) {
                            return ''
                        }
                        let line = [params1.name || params2.name]
                        if (params1) {
                            line.push(`${params1.marker}${params1.seriesName}：${params1.value}元`)
                        }
                        if (params2) {
                            line.push(`${params2.marker}${params2.seriesName}：${params2.value}元`)
                        }
                        return line.join('<br/>')
                    },
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    top: '25px',
                    selected: {
                        '支出': this.query.payType == '支出',
                        '收入': this.query.payType == '收入',
                    }
                },
                grid: {
                    top: '65px',
                    left: '10px',
                    right: '20%',
                    bottom: '30px',
                    containLabel: true,
                    height: (monthArray.length * oneHeight) + 'px'
                },
                yAxis: {
                    type: 'category',
                    nameTextStyle: {
                        color: '#444',
                        fontSize: 13
                    },
                    boundaryGap: true,
                    data: monthArray,
                    axisLabel: {
                        color: '#444'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                xAxis: {
                    show: false,
                },
                series: [
                    {
                        name: '支出',
                        type: 'bar',
                        data: outcomeArray,
                        itemStyle: {
                            color: this.getColorRgba('#3eb475',0.8),
                        },
                        barWidth: '40%',
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{c}元',
                            color: '#666',
                            fontSize: 13,
                            distance: 2,
                        }
                    },
                    {
                        name: '收入',
                        type: 'bar',
                        data: incomeArray,
                        itemStyle: {
                            color: this.getColorRgba('#eeb63b', 0.8),
                        },
                        barWidth: '40%',
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{c}元',
                            color: '#666',
                            fontSize: 13,
                            distance: 2,
                        },
                        selectedMode: true,
                        select: {
                            disabled: true,
                            itemStyle: {
                                color: primaryColor,
                                borderWidth: 0
                            }
                        }
                    }
                ]
            }
            this.monthEcharts.setOption(option);
        },
        handleQueryPayDate() {
            this.$refs['date_select_drawer'].init(this.query.payDate, '请选择日期')
        },
        handleSelectDate(value) {
            this.query.payDate = value
            this.getReports()
        },
        handlePayType() {
            this.getReports()
        },
        handleTagsListItem(item) {
            this.$router.push(`/payment/tag-records?payDate=${this.query.payDate}&payType=${this.query.payType}&tag=${item.tag}`)
        },
        getColorRgba(color, alpha) {
            const r = parseInt(color.slice(1, 3), 16)
            const g = parseInt(color.slice(3, 5), 16)
            const b = parseInt(color.slice(5, 7), 16)
            return `rgba(${r}, ${g}, ${b}, ${alpha})`
        },
        getPercent(percent) {
            const largePercent = this.tagsData[0].percent
            const expand = 100 / largePercent
            return (percent * expand) || 1
        }
    }
}
</script>

<style lang="less" scoped>
.reports-container {
    width: 100%;
    background: #fff;
    min-height: 100vh;
    box-sizing: border-box;
    padding-bottom: 80px;
    .reports-header {
        background: var(--primary-color);
        padding: 40px 25px;
        box-sizing: border-box;
        .header-query {
            display: flex;
            justify-content: space-between;
            .query-item {
                color: #fff;
                border-radius: 2px;
                cursor: pointer;
                user-select: none;
                display: flex;
                align-items: center;
                font-size: 18px;
                .item-line {
                    display: inline-block;
                    margin: 0 4px;
                    height: 10px;
                    width: 0px;
                }
                .item-pay-type {
                    margin-right: 15px;
                    font-size: 15px;
                    padding: 5px 10px;
                    border-radius: 5px;
                    color: rgba(255, 255, 255, 0.6);
                    cursor: pointer;
                    &:last-child {
                        margin: 0;
                    }
                }
                .item-pay-type-active {
                    background: rgba(255, 255, 255, 0.2);
                    color: #fff;
                }
            }
        }
        .header-report {
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            font-size: 16px;
            line-height: 40px;
            color: #fff;
            .report-title {
                color: rgba(255, 255, 255, 0.6);
            }
            .report-price {
                margin-top: 10px;
                font-size: 46px;
                font-weight: bold;
                .price-value {
                    position: relative;
                    &::after {
                        content: '元';
                        position: absolute;
                        bottom: 0px;
                        right: -30px;
                        font-size: 20px;
                        color: rgba(255, 255, 255, 0.8);
                    }
                }
            }
        }
    }
    .reports-tags {
        padding: 30px 25px 0 25px;
        .tags-title {
            font-size: 18px;
            color: #444;
        }
        .tags-list {
            margin-bottom: 30px;
            .list-item {
                display: flex;
                align-items: center;
                padding-bottom: 24px;
                cursor: pointer;
                &:last-child {
                    padding-bottom: 30px;
                    border-bottom: 1px solid #eee;
                }
                .item-index {
                    height: 26px;
                    line-height: 26px;
                    width: 26px;
                    border-radius: 50%;
                    background: var(--primary-color);
                    text-align: center;
                    color: #fff;
                    box-sizing: border-box;
                }
                .item-title {
                    padding: 0 10px;
                    min-width: 90px;
                    font-size: 16px;
                }
                .item-percent {
                    flex: 1;
                    .percent-value {
                        width: 0;
                        height: 6px;
                        border-radius: 10px;
                        background: var(--primary-color);
                    }
                }
                .item-price {
                    padding: 0 5px 0 10px;
                    font-size: 16px;
                }
                .item-more {
                    color: #aaa;
                }
            }
        }
    }
    .reports-month {
        padding: 0px 25px 0 25px;
        .month-title {
            font-size: 18px;
            color: #444;
        }
    }
}

</style>
